// extracted by mini-css-extract-plugin
export default {"blogTitle":"style_blogTitle__aw9Rr","blogContent":"style_blogContent__E2hhy","imgs":"style_imgs__aXB3q","auction":"style_auction__C5H9T","twoCol":"style_twoCol__1U1aW"};